import { render, staticRenderFns } from "./ForumlaEidtor.vue?vue&type=template&id=d9fd2820&scoped=true"
import script from "./ForumlaEidtor.vue?vue&type=script&lang=js"
export * from "./ForumlaEidtor.vue?vue&type=script&lang=js"
import style0 from "./ForumlaEidtor.vue?vue&type=style&index=0&id=d9fd2820&prod&scoped=true&lang=scss"
import style1 from "./ForumlaEidtor.vue?vue&type=style&index=1&id=d9fd2820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fd2820",
  null
  
)

export default component.exports